import styled from 'styled-components';
import { Tree } from 'antd';

export const StyledFormType = styled.div`
  display: flex;
  justify-content: center;
  font-weight: bold;
  width: 100%;  /* Make sure it takes full width for centering */
`;


export const CardTitle = styled.div`
  padding: 0px 0px 6px;
  font-weight: bolder;
`;

export const CardFooterActions = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px;
`;


export const StyledSubForm = styled.div`
  padding: 20px;
  min-height: 300px;
`;

export const StyledSubHeading = styled.div`
  display: flex;
  justify-content: center;
  font-weight: bold;
`;

export const StyledTabsContent = styled.div`
  margin-top: 20px;
  color: black;
  fontweight: bold;
`;

export const StyledTree = styled(Tree)`
  background: #1a3652 !important;
  color: white !important;
`;

export const StyledBoxTable = styled.div` 
  margin-top: 10px;
  width: 100%;
  padding:10px;
  `;
export const StyledBoxHeader = styled.div` 
  margin-top: 10px;
  width: 100%;
  padding:10px;
  `;

export const StyledBox = styled.div`  
  width: 100%;
  padding:10px 0px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr); // 1 per row on small screens
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr); // 2 per row on tablets
  }

  @media (min-width: 1025px) {
    grid-template-columns: repeat(4, 1fr); // 4 per row on desktops
  }
`;
export const StyledBoxLabel = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;      /* vertical center with flex */
  background:  ${(props) =>
    props.headerBgColor ? props.headerBgColor : 'rgb(39, 43, 52)'} !important;
  height: 40px;          
  padding: 0;              
  margin: 0;             
  box-sizing: border-box;

  @media (max-width: 768px) {
    justify-content: flex-start;
    padding-left: 8px;
  }

  /* Reset margin on Typography.Title inside */
  & .ant-typography {
    margin: 0;
  }
`;
